// @ts-nocheck
/**
 * Generated by orval v7.4.1 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { ResponsibilitiesEvaluation } from './responsibilitiesEvaluation';
import type { ResponsibilitiesEvents } from './responsibilitiesEvents';

/**
 * API schema for responsibility assignments.

Defines who is responsible for:
- evaluation: grading module submissions
- events: managing specific event kinds (by event_kind_id)
 */
export interface Responsibilities {
  evaluation?: ResponsibilitiesEvaluation;
  events?: ResponsibilitiesEvents;
}
